import clsx from 'clsx';
import React from 'react';
import style from './index.module.scss';
import { Theme, Typography, useMediaQuery } from '@mui/material';
import YoutubeSearchedForIcon from '@mui/icons-material/YoutubeSearchedFor';
import { useTranslate } from 'hooks/use-translate';
import { MobileEmptyState } from 'components/mobile-empty-state';

interface Props {
  className?: string;
  title?: React.ReactNode | string;
}

export const DataGridEmpty: React.FC<React.PropsWithChildren<Props>> = ({ className, title }) => {
  const { t } = useTranslate();
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  const TitleComponent = title || t('no-data');
  // N2 (T5): below md every list's empty state is the one component
  if (isMobile) {
    return (
      <div className={clsx(style.wrap, className)}>
        <MobileEmptyState />
      </div>
    );
  }
  return (
    <div className={clsx(style.wrap, className)}>
      <div className={style.data}>
        <YoutubeSearchedForIcon className={style.icon} />
        <Typography variant={isMobile ? 'h4' : 'h3'} component={'div'}>
          {TitleComponent}
        </Typography>
      </div>
    </div>
  );
};
